export default (eventType) => {
	if (!window?.DDC?.dataLayer?.vehicles?.[0]) {
		return null;
	}

	const vehicleImage = window.DDC.dataLayer.vehicles[0].images[0];

	// vehicleImage can either be a string or an object
	const imageLink =
		typeof vehicleImage === 'object' ? vehicleImage.uri : vehicleImage;

	if (imageLink.includes('fd-FD_DEALERSERVICES_IMAGES')) {
		return `vinreal:${eventType}`;
	}

	// We are testing for something like pictures.dealer.com/a/
	if (
		/(http|https):\/\/(pictures|pictures-np)\.dealer\.com\/[a-zA-Z]\//.test(
			imageLink
		)
	) {
		return `dealer:${eventType}`;
	}

	return `stock:${eventType}`;
};
